export function EtooMark({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <linearGradient id="etoo-mark-bg-brk" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="100%" stopColor="#a78bfa" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="30" height="30" rx="6" fill="url(#etoo-mark-bg-brk)" />
      <rect x="1" y="1" width="30" height="30" rx="6" fill="none" stroke="rgba(255,255,255,0.28)" strokeWidth="1.2" />
      <g fill="none" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round">
        <path d="M22.6 14 C22.1 11.7 19.5 10.5 16.2 10.5 C12.8 10.5 10.7 13 10.7 16.5 C10.7 20 12.8 22.5 16.2 22.5 C19.5 22.5 22.1 21.3 22.6 19" />
        <line x1="11.5" y1="16.5" x2="24.2" y2="16.5" />
      </g>
    </svg>
  );
}

export function EtooLogo() {
  return (
    <a href="/" title="etoo — all games" aria-label="etoo — all games" className="etoo-logo">
      <EtooMark size={26} />
      <span>etoo</span>
    </a>
  );
}
